import { SidebarLayout } from "../components/SidebarLayout";
import "@fontsource/allura/latin-400.css";
import "../styles/bio-refresh.css";
import "../styles/policy-refresh.css";
import { policyPath, site, type PolicyKey } from "../config/site";
import { policyPages } from "../data/policyPages";
import { ToolNavigation } from "../components/ToolNavigation";
import { SiteFooter } from "../components/SiteFooter";

export function policyHead(page: PolicyKey) {
  const { title, description } = policyPages[page];
  const canonical = `${site.origin}${policyPath(page)}`;
  return {
    meta: [
      { title: `${title} | ${site.name}` },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonical }
    ],
    links: [{ rel: "canonical", href: canonical }]
  };
}

export function PolicyPage({ page }: { page: PolicyKey }) {
  const content = policyPages[page];
  const updated = new Intl.DateTimeFormat("en", {
    dateStyle: "long", timeZone: "UTC"
  }).format(new Date(`${content.lastUpdated}T00:00:00Z`));

  return (
    <div className="site-shell bio-refresh policy-shell">
      <a className="policy-skip-link" href="#policy-content">Skip to content</a>
      <header className="topbar policy-topbar">
        <a className="brand" href="/">
          <span className="brand-mark" aria-hidden="true"><img src="/favicon-96x96.png" alt="" width={38} height={38} /></span>
          <span>{site.name}</span>
        </a>
        <ToolNavigation />
      </header>
      <SidebarLayout><main id="policy-content" className="policy-main" tabIndex={-1}>
        <article className="policy-article" aria-labelledby="policy-title">
          <header className="policy-heading">
            <p className="policy-eyebrow">Aesthetic Bio Maker · Site information</p>
            <h1 id="policy-title">{content.title}</h1>
            <p className="policy-intro">{content.intro}</p>
            <p className="policy-updated">Last updated <time dateTime={content.lastUpdated}>{updated}</time></p>
          </header>
          {content.sections.map((section) => (
            <section key={section.id} id={section.id} aria-labelledby={`${section.id}-heading`}>
              <h2 id={`${section.id}-heading`}>{section.title}</h2>
              {section.content}
            </section>
          ))}
        </article>
      </main></SidebarLayout>
      <SiteFooter appearance="brand" />
    </div>
  );
}
